<template>
<!--  -->
  <div class='corp-credit-sum'>
      <!-- <div class="ajFlex c-page-top" style="justify-content: flex-end;">
          <Button type="info" ghost @click="handleBack">返回</Button>
      </div> -->
      <div style='background: #fff;padding: 20px;'>
        <div class="titleMain">
          <span class="titleSpan">黑名单</span>
          <Icon type="ios-arrow-forward" />
          <span class="titleName">{{corpBaseInfoVO.corpName}}</span>
        </div>
        <div class='content'>
          <div class='title'>
            <Icon type="ios-bookmark" style="color: #3284FF;" /><span>企业基本信息</span>
          </div>
          <div class='form'>
            <Row>
              <Col span="12">
                <div class='form-item'>
                  <p class='label'>企业名称</p>
                  <p class='value' style='font-weight: 600;'>{{corpBaseInfoVO.corpName}}</p>
                </div>
              </Col>
              <Col span="12">
                <div class='form-item'>
                  <p class='label'>统一社会信用代码</p>
                  <p class='value no-border-right'>{{corpBaseInfoVO.corpCode}}</p>
                </div>
              </Col>
              <Col span="12">
                <div class='form-item'>
                  <p class='label'>企业法定代表人</p>
                  <p class='value'>{{corpBaseInfoVO.legalMan}}</p>
                </div>
              </Col>
              <Col span="12">
                <div class='form-item'>
                  <p class='label'>注册所在地</p>
                  <p class='value no-border-right'>{{corpBaseInfoVO.registerAddress}}</p>
                </div>
              </Col>
              <Col span="24">
                <div class='form-item'>
                  <p class='label'>项目经营地址</p>
                  <p class='value no-border-right'>{{corpBaseInfoVO.address}}</p>
                </div>
              </Col>
              <Col span="12">
                <div class='form-item'>
                  <p class='label'>企业成立时间</p>
                  <p class='value'>{{corpBaseInfoVO.corpBirthDate && corpBaseInfoVO.corpBirthDate.split('T')[0]}}</p>
                </div>
              </Col>
              <Col span="12">
                <div class='form-item'>
                  <p class='label'>企业登记注册类型</p>
                  <p class='value no-border-right'>{{filterCompanyType}}</p>
                </div>
              </Col>
              <Col span="12">
                <div class='form-item'>
                  <p class='label no-border-bottom'>信用评分</p>
                  <p class='value no-border-bottom'>{{corpBaseInfoVO.creditScore}}</p>
                </div>
              </Col>
              <Col span="12">
                <div class='form-item'>
                  <p class='label no-border-bottom'>评分更新时间</p>
                  <p class='value no-border-right no-border-bottom'>{{corpBaseInfoVO.updateDate}}</p>
                </div>
              </Col>
            </Row>
          </div>
          <div class='tables' style="margin-top: 20px;">
            <Tabs value="name1">
                <TabPane label="黑名单总览" name="name1">
                  <Table border :columns="blackColumns" :data="tableData" highlight-row></Table>
                </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getBlackListByCorpCode, getBlackListInfoByCorpCode, getCompanyType } from '@/api/homePage.js';

export default {
  name: '',
  props: {

  },
  data () {
    return {
      corpBaseInfoVO: {

      },
      tableData: [],
      companyType: [],
      blackColumns: [
          {
              title: '序号',
              type: 'index',
              width: 70,
              align: 'center'
          },
          {
              title: '黑名单类型',
              key: 'blackType',
              minWidth: 220,
              align: 'center'
          },{
              title: '列入部门',
              key: 'cognizanceDepartment',
              width: 150,
              align: 'center'
          },
          {
              title: '列入日期',
              key: 'blacklistStartDate',
              width: 160,
              align: 'center'
          },
          {
              title: '移出日期',
              key: 'blacklistEndDate',
              width: 180,
              align: 'center'
          },
          {
              title: '管理期限',
              key: 'glqx',
              width: 140,
              align: 'center'
          },
          {
              title: '列入依据',
              key: 'cognizanceBasis',
              minWidth: 220,
              align: 'center'
          }
      ]
    }
  },
  mixins: [],
  components: {

  },
  computed: Object.assign({
      filterCompanyType() {
        if(this.companyType.length > 0 && this.corpBaseInfoVO.economicNum != null) {
            return this.companyType.find(it => it.typeCode == this.corpBaseInfoVO.economicNum).typeInfo
        }
        return ''
      }
  }, mapGetters([
        '_dict'
    ])
  ),
  watch: {

  },
  created () {
    // console.log(this.$store.state)
    const corpCode = this.$route.query.corpCode;
    getBlackListByCorpCode(corpCode).then((res) => {
      if (res.status !== 200) return
      if (Array.isArray(res.data)) {
        res.data.map((item) => {
          item.glqx = '一年'
          this._dict.black_type.map((it) => {
            if (item.blackType == it.dicCode) {
              item.blackType = it.dicName
            }
          })
        })
        this.tableData = res.data
      }
    }).catch(() => {
      this.$Message.error('获取详情失败！')
      this.handleBack()
    })
    getBlackListInfoByCorpCode(corpCode).then((res) => {
      if (res.status != 200) return
      this.corpBaseInfoVO = res.data.corpBaseInfoVO || {}
    }).catch(() => {
      this.$Message.error('获取详情失败！')
      this.handleBack()
    })
     getCompanyType().then((res) => {
        // console.log(res, 'getCompanyType')
        this.companyType = res.data || []
    })
  },
  mounted () {

  },
  methods: {
    handleBack() {
        this.$router.go(-1);
    }
  }
}
</script>

<style lang="less" scoped>
.corp-credit-sum {
  background: #f5f5f5;
  padding: 30px 8%;
}
.titleMain {
    height: 40px;
    line-height: 40px;
    .titleSpan {
        font-size: 12px;
        color: gray;
    }
    .titleName {
        font-size: 12px;
    }
}
.content{
  .title{
    font-size: 18px;
    &>span{
      font-size: 16px;
      font-weight: 600;
    }
  }
  .form {
    margin: 12px 0px;
    border: 1px solid #E9E9E9;
    .form-item {
      display: flex;
      flex-direction: row;
      height: 50px;
      .label{
        width: 200px;
        padding: 12px 16px;
        // background: #F9F9F9;
        font-size: 12px;
        text-align: right;
        font-weight: 600;
        line-height: 26px;
        border-right: 1px solid #E9E9E9;
        border-bottom: 1px solid #E9E9E9;
      }
      .value{
        flex: 1;
        padding: 12px 16px;
        font-size: 12px;
        line-height: 26px;
        border-right: 1px solid #E9E9E9;
        border-bottom: 1px solid #E9E9E9;
        background: #fff;
      }
      .value.no-border-right {
        border-right: none;
      }
      .label.no-border-bottom, .value.no-border-bottom {
        border-bottom: none;
      }
    }
  }
}
</style>
<style lang="less">
  .tables {
    /deep/.ivu-tabs-nav-scroll {
      background: #fff;
    }
  }
</style>
